import React, { createContext, useContext, useEffect, useState } from 'react'
import jwtDecode from 'jwt-decode'

interface TenantContextType {
  tenantId: number | null
  isFashionTenant: boolean
  isAcoTenant: boolean
  needsRelogin: boolean
  setNeedsRelogin: (v: boolean) => void
}

interface DecodedToken {
  tenantId?: number
  [key: string]: any
}

const TenantContext = createContext<TenantContextType>({
  tenantId: null,
  isFashionTenant: false,
  isAcoTenant: false,
  needsRelogin: false,

  setNeedsRelogin: () => {}
})

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tenantId, setTenantId] = useState<number | null>(null)
  const [needsRelogin, setNeedsRelogin] = useState<boolean>(false)

  useEffect(() => {
    const token = localStorage.getItem('token')
    const currentPath = window.location.pathname
    const isPublicPath = ['/', '/login', '/pendingmessage', '/completeRegister', '/accessvalidation', '/internalaccess'].some((path) => currentPath.startsWith(path))
    if (token) {
      try {
        const decoded = jwtDecode<DecodedToken>(token)

        if (decoded.tenantId) {
          setTenantId(decoded.tenantId)
          setNeedsRelogin(false)
        } else {
          console.warn('⚠️ TenantId ausente no token JWT; algumas funcionalidades podem falhar até que o usuário faça login com um token válido.');
          setTenantId(null)
          if (!isPublicPath) {
            setNeedsRelogin(true)
          }
        }
      } catch (error) {
        console.warn('Erro ao decodificar token para obter tenantId:', error)
        setTenantId(null)
      }
    } else {
      console.warn('⚠️ Nenhum token encontrado no localStorage; TenantId não definido.');
      if (!isPublicPath) {
        setNeedsRelogin(true)
      }
    }
  }, [])

  const value: TenantContextType = {
    tenantId,
    isFashionTenant: tenantId === 2,
    isAcoTenant: tenantId === 1,
    needsRelogin,
    setNeedsRelogin
  }

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  )
}

export const useTenant = () => {
  const context = useContext(TenantContext)
  if (!context) {
    throw new Error('useTenant deve ser usado dentro de um TenantProvider')
  }
  return context
}

export default TenantContext